import React from 'react';

interface MetricCardProps {
  title: string;
  description: string;
  value: string | number;
  trend?: string;
  icon: string;
  delay?: number;
  hideTrend?: boolean;
  invertTrendColor?: boolean;
}

export const MetricCard: React.FC<MetricCardProps> = ({ title, description, value, trend, icon, delay = 0, hideTrend = false, invertTrendColor = false }) => {
  const getTrendClasses = () => {
    if (!trend) return '';
    
    const isPositive = trend.startsWith('+');
    
    if (invertTrendColor) {
      return isPositive ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800';
    }
    
    return isPositive ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800';
  };
  
  return (
    <div 
      className="bg-white/70 backdrop-blur-sm p-4 rounded-xl border border-slate-200/50 h-full flex flex-col justify-between transition-all duration-300 hover:border-slate-300 hover:shadow-sm"
      style={{ animation: `fadeInUp 0.5s ${delay}s ease-out backwards` }}
    >
      <div>
        <div className="flex justify-between items-start">
          <h3 className="font-semibold text-slate-900 text-base">{title}</h3>
          <span className="text-2xl">{icon}</span>
        </div>
        <p className="text-xs text-slate-500 mt-1">{description}</p>
      </div>
      <div className="flex justify-between items-end mt-4">
        <p className="text-3xl font-bold text-slate-900">{value}</p>
        {!hideTrend && trend && (
          <span className={`text-sm font-semibold px-2 py-0.5 rounded-full ${getTrendClasses()}`}>
            {trend}
          </span>
        )}
      </div>
      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}; 